import * as types from "./actionTypes";

export function resizeWindow(ui) {
    return {
        type: types.UI_RESIZE_WINDOW,
        ui: ui
    };
}

export function setNewUI(value) {
    return {
        type: types.SET_NEW_UI,
        newUI: value
    };
}

export function setDeveloperMode(value) {
    return {
        type: types.SET_DEVELOPER_MODE,
        developerMode: value
    };
}

export function setHideNewButton(value) {
    return {
        type: types.SET_HIDE_NEW_BUTTON,
        hideNewButton: value
    };
}
